import styled, { keyframes } from 'styled-components';

import { getColor } from '../../../../../stylesheets/tools';

const getTransformAnimation = initial => keyframes`
  0% { transform: translateX(${initial}%) scale(0.7); }
  100% { transform: translateX(${Math.abs(initial) * 4 + 100}%) scale(1.3); }
`;
const flashAnimation = keyframes`
  0% {
    filter: blur(10px);
    opacity: 0;
  }
  
  10% {
    opacity: 1;
    filter: blur(0px);
  }

  40% {
    opacity: 1;
    filter: blur(0px);
  }
  
  100% {
    filter: blur(10px);
    opacity: 0;
  }
`;

const StyledFlash = styled.div`
  position: relative;
  width: 100vw;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  filter: blur(10px);
  opacity: 0;
  animation: ${flashAnimation} ${p => 20 - p.$delay}s ${p => p.$delay}s linear forwards;

  & > div {
    content: '';
    height: 24px;
    width: 300px;
    grid-row: 1;
    z-index: 1;
    justify-self: center;
    filter: blur(10px);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      ${getColor('white')} 25%,
      ${getColor('white')} 50%,
      ${getColor('white')} 75%,
      rgba(255, 255, 255, 0) 100%
    );

    &:nth-of-type(1) {
      animation: ${props => getTransformAnimation(props.$first)} 20s linear forwards;
    }

    &:nth-of-type(2) {
      animation: ${props => getTransformAnimation(props.$second)} 20s linear forwards;
    }
  }
`;

export default StyledFlash;
